import { TransactionType } from '../../../@types/types'

export function getRealEstateType(category: string, transaction: TransactionType) {
  return (category + '_' + (transaction.toLowerCase() === 'sell' ? 'buy' : transaction)).toUpperCase()
}
